<div class="chase-detail-info__pursuit-item bold">Chase <a routerLink="{{url}}" href="#">{{chaseId}}</a> - {{pursuitType}}</div>

